<template>
<div style="position: relative;height:100%;height:100%">
  <el-button style="position:fixed" size="mini" type="warning" @click="back()">退出</el-button>
  <iframe style="height:100%;width:100%" src="https://school.mibee.cn/"></iframe>
</div>
</template>

<script>

export default {
  data () {
    return {
    
    }
  },

  computed: {


  
  
    
  },
  mounted: function () {



  },
  methods: {
    back(){
      window.localStorage.removeItem('project');
                this.$router.push({ name: "ProjectList" });
    }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/School/Index.vue